import { render, staticRenderFns } from "./ModalDownloadMutasi.vue?vue&type=template&id=36cb9c8f&"
import script from "./ModalDownloadMutasi.vue?vue&type=script&lang=js&"
export * from "./ModalDownloadMutasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports